import script from "./codeDiffEditor.vue?vue&type=script&lang=js"
export * from "./codeDiffEditor.vue?vue&type=script&lang=js"

import "./codeDiffEditor.vue?vue&type=style&index=0&id=1463780a&lang=css"

const __exports__ = script;

export default __exports__